import { render, staticRenderFns } from "./ManageAdvantagesSection.vue?vue&type=template&id=636336fe&scoped=true&"
import script from "./ManageAdvantagesSection.vue?vue&type=script&lang=js&"
export * from "./ManageAdvantagesSection.vue?vue&type=script&lang=js&"
import style0 from "./ManageAdvantagesSection.vue?vue&type=style&index=0&id=636336fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636336fe",
  null
  
)

export default component.exports